<p-card>
    <ng-template pTemplate="header">
        <h5 class="pdfs-15">Paymets cards</h5>
    </ng-template>
    <div class="mT-15">
        <span class="bfs19">
            No payment cards yet
        </span>
    </div>
    <div class="mT-15">
        <span class="mfs13">
            Click on the the button below to add a new payment card, all brands accepted.
        </span>
    </div>
    <div class="mT-15">
        <span class="mfs13">
            <button pButton pRipple type="button" icon = "pi pi-money-bill" label="Add new card" class="p-button-raised p-button-success fR"></button>
        </span>
    </div>
    <ng-template pTemplate="footer">
    </ng-template>
</p-card>